import Connector from '../../agent';
import types from './types';
import { takeQuery } from 'react-lib/dist/agent-es';

const Common = {
  getNotification: () => Connector.api.get('/common/notification')
};

const commonSagas = [takeQuery(types.GET_NOTIFICATION, Common.getNotification)];

export default commonSagas;
